import { sanitizeQuantity } from "./cftCalculator";

/**
 * Row-level validation for quotation inventory lines.
 * Empty item + empty quantity => no errors (row ignored for save).
 * quantity > 0 => cftPerItem required and must be > 0.
 */
export function validateQuotationItem(row) {
  const item = (row.item || "").trim();
  const qtyStr = row.quantity;

  const qtyEmpty = qtyStr === "" || qtyStr === null || qtyStr === undefined;
  if (!item && qtyEmpty) {
    return { quantity: "", cftPerItem: "" };
  }

  if (!item) {
    return { quantity: "", cftPerItem: "" };
  }

  if (qtyEmpty) {
    return { quantity: "Quantity is required", cftPerItem: "" };
  }

  const qtyState = sanitizeQuantity(qtyStr);
  if (!qtyState.isValid) {
    return { quantity: qtyState.error || "Enter a valid number", cftPerItem: "" };
  }

  const q = qtyState.value;
  if (q === 0) {
    const cftRaw = row.cftPerItem;
    if (cftRaw !== "" && cftRaw !== null && cftRaw !== undefined) {
      const n = Number(cftRaw);
      if (!Number.isFinite(n) || n < 0) {
        return { quantity: "", cftPerItem: "Enter valid non-negative CFT" };
      }
    }
    return { quantity: "", cftPerItem: "" };
  }

  const cftRaw = row.cftPerItem;
  if (cftRaw === "" || cftRaw === null || cftRaw === undefined) {
    return { quantity: "", cftPerItem: "CFT is required when quantity is greater than 0" };
  }
  const cftNum = Number(cftRaw);
  if (!Number.isFinite(cftNum) || cftNum <= 0) {
    return { quantity: "", cftPerItem: "Enter CFT for this item before saving" };
  }

  return { quantity: "", cftPerItem: "" };
}

export function applyQuotationValidationToRow(row) {
  const errs = validateQuotationItem(row);
  return {
    ...row,
    quantityError: errs.quantity,
    cftError: errs.cftPerItem,
  };
}

export function validateQuotationRowsForSave(rows) {
  let firstInvalidId = null;
  const updated = rows.map((row) => {
    const next = applyQuotationValidationToRow(row);
    const hasErr = !!(next.quantityError || next.cftError);
    if (hasErr && firstInvalidId == null) firstInvalidId = next.id;
    return next;
  });
  const valid = !updated.some((row) => !!(row.quantityError || row.cftError));
  return { rows: updated, valid, firstInvalidId };
}
